// hooks/useScript.ts
import { useEffect, useState } from "react";

export function useScript(src: string): "idle" | "loading" | "ready" | "error" {
  const [status, setStatus] = useState<"idle" | "loading" | "ready" | "error">(
    src ? "loading" : "idle"
  );

  useEffect(() => {
    if (!src) return;

    const existingScript = document.querySelector(
      `script[src="${src}"]`
    ) as HTMLScriptElement;
    if (existingScript) {
      setStatus("ready");
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => setStatus("ready");
    script.onerror = () => setStatus("error");

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [src]);

  return status;
}
